function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Progress component
 * 
 */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './Progress.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PROGRESS = [{
  name: 'Details',
  path: /details/
}, {
  name: 'Summary',
  path: /summary/
}, {
  name: 'Payment',
  path: /payment|completed/
}
// {name: 'Confirmation', path: /confirmation/}
];
export class Progress extends Component {
  render() {
    const {
      location
    } = this.props;
    let steps = [];
    for (let i = 0; i < PROGRESS.length; i++) {
      const progress = PROGRESS[i];
      let classes = `step${progress.path.test(location.pathname) ? ' active' : ''}`;
      steps.push(/*#__PURE__*/_jsxs("li", {
        className: classes,
        children: [/*#__PURE__*/_jsx("div", {
          className: "number-container",
          children: /*#__PURE__*/_jsx("span", {
            className: "number",
            children: parseInt(i) + 1
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "name",
          children: progress.name
        })]
      }, i));
    }
    return /*#__PURE__*/_jsx("section", {
      className: "progress",
      children: /*#__PURE__*/_jsx("ul", {
        className: "inner",
        children: steps
      })
    });
  }
}
_defineProperty(Progress, "defaultProps", {
  location: {
    pathname: '/'
  }
});
export default withRouter(Progress);